import React from 'react';
import PropTypes from 'prop-types';
import {
  PAPER_TABS,
  Spacing_Base,
  FontSize_Css_Plus,
  AUDIO_PAPER_TYPE,
} from '../../../data/common';
import { strParse } from '../../../lib/util';

function FTypeTestRow({ vocaList = {}, startNo, tab, config }) {
  let audioType = vocaList?.questions[0]?.audioQuestionType;
  // console.log('vocabList F:', vocaList);

  return (
    <div style={{ width: '100%', marginTop: '20px', paddingBottom: '15px' }}>
      {tab !== PAPER_TABS.ANSWER && (
        <div
          style={{
            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
            fontWeight: 700,
            fontFamily: "'Pretendard', Arial, sans-serif",
            marginBottom: `${config?.spacing * Spacing_Base}px`,
          }}
        >
          ※&nbsp;{vocaList?.title}
        </div>
      )}
      <div>
        {vocaList?.questions?.map((voca, idx) => {
          return (
            <div
              key={`${voca.questions}-${String(idx)}`}
              style={{
                height: 'auto',
                width: '100%',
                marginTop: `${config?.spacing * Spacing_Base}px`,
                fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                fontFamily: "'Pretendard', Arial, sans-serif",
                display: 'grid',
                gridTemplateColumns: '1.2fr 8.8fr',
                justifyContent: 'space-between',
                alignItems: 'start',
              }}
            >
              <div style={{ minWidth: '10px' }}>{startNo + idx}.</div>
              <div
                style={{
                  flexGrow: 1,
                  minHeight: '18px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  // tab === PAPER_TABS.ANSWER ? 'flex-start' : 'space-between',
                  gap: '15px',
                  wordBreak: 'break-all',
                  fontFamily: "'Pretendard', Arial, sans-serif",
                }}
              >
                {audioType === AUDIO_PAPER_TYPE.ENG && (
                  <div
                    style={{
                      minHeight: '15px',
                      width: '150px',
                      fontFamily: "'Pretendard', Arial, sans-serif",
                      borderBottom:
                        tab === PAPER_TABS.ANSWER ? 'none' : '1px solid #000',
                      textAlign:
                        tab === PAPER_TABS.ANSWER ||
                        (tab === PAPER_TABS.TEST_PAPER &&
                          config?.vocaFirstWordShow)
                          ? 'left'
                          : 'center',
                    }}
                  >
                    {tab === PAPER_TABS.TEST_PAPER && ''}
                    {tab === PAPER_TABS.TEST_PAPER &&
                      config?.vocaFirstWordShow &&
                      voca?.answer[0]}
                    {tab === PAPER_TABS.ANSWER && voca.answer}
                    {tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                      strParse(voca.answer)}
                  </div>
                )}
                {audioType === AUDIO_PAPER_TYPE.KOR && (
                  <div
                    style={{
                      minHeight: '15px',
                      width: '150px',
                      fontFamily: "'Pretendard', Arial, sans-serif",
                      borderBottom:
                        tab === PAPER_TABS.ANSWER ? 'none' : '1px solid #000',
                      textAlign: tab === PAPER_TABS.ANSWER ? 'left' : 'center',
                    }}
                  >
                    {tab === PAPER_TABS.TEST_PAPER && ''}
                    {tab === PAPER_TABS.ANSWER && strParse(voca.meanings)}
                    {tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                      strParse(voca.meanings)}
                  </div>
                )}
                {audioType === AUDIO_PAPER_TYPE.ENG_KOR && (
                  <>
                    <div
                      style={{
                        minHeight: '15px',
                        width: tab === PAPER_TABS.ANSWER ? 'auto' : '150px',
                        fontFamily: "'Pretendard', Arial, sans-serif",
                        borderBottom:
                          tab === PAPER_TABS.ANSWER ? 'none' : '1px solid #000',
                        textAlign:
                          tab === PAPER_TABS.ANSWER ||
                          (tab === PAPER_TABS.TEST_PAPER &&
                            config?.vocaFirstWordShow)
                            ? 'left'
                            : 'center',
                      }}
                    >
                      {tab === PAPER_TABS.TEST_PAPER && ''}
                      {tab === PAPER_TABS.TEST_PAPER &&
                        config?.vocaFirstWordShow &&
                        voca?.answer[0]}
                      {tab === PAPER_TABS.ANSWER && strParse(voca.answer)}
                      {tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                        strParse(voca.answer)}
                    </div>
                    <div
                      style={{
                        minHeight: '15px',
                        width: tab === PAPER_TABS.ANSWER ? 'auto' : '150px',
                        fontFamily: "'Pretendard', Arial, sans-serif",
                        borderBottom:
                          tab === PAPER_TABS.ANSWER ? 'none' : '1px solid #000',
                        textAlign:
                          tab === PAPER_TABS.ANSWER ? 'left' : 'center',
                      }}
                    >
                      {tab === PAPER_TABS.TEST_PAPER && ''}
                      {tab === PAPER_TABS.ANSWER && strParse(voca.meanings)}
                      {tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                        strParse(voca.meanings)}
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

FTypeTestRow.propTypes = {
  tab: PropTypes.string.isRequired,
  config: PropTypes.object,
  vocaList: PropTypes.object,
  startNo: PropTypes.number,
};

export default FTypeTestRow;

  /* {
    <div
      style={{
        minHeight: '15px',
        width: '150px',
        fontFamily: "'Pretendard', Arial, sans-serif",
      }}
    >
      {tab === PAPER_TABS.TEST_PAPER && ''}
      {(tab === PAPER_TABS.ANSWER_TEST_PAPER ||
        tab === PAPER_TABS.ANSWER) &&
        strParse(voca.answer)}
    </div>
    {(tab === PAPER_TABS.TEST_PAPER ||
      tab === PAPER_TABS.ANSWER_TEST_PAPER) && (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '15px',
        }}
      >
        <div
          style={{
            borderBottom: '1px solid #000',
            width: '150px',
            minWidth: '100px',
          }}
        />
        {audioType === AUDIO_PAPER_TYPE.ENG_KOR && (
          <div
            style={{
              borderBottom: '1px solid #000',
              width: '150px',
              minWidth: '100px',
            }}
          />
        )}
      </div>
    )}
}  */ 
